<template>
    <div class="dialog-screen">
        <el-table class="thin" :data="pagedevcBrandImpInfoList" ref="deviceImpInfoTable" border :row-key="rowItemKey" style="width: 100%; font-size: 12px">
            <el-table-column label="行号" width="60" align="center" type="index" :index="getRowNo"></el-table-column>
            <el-table-column label="名称" prop="name">
                <template slot-scope="rows">
                    <el-input :disabled="rows.row.execState == 2" type="text" @change="handleChangeEvent(rows.row)" v-model="rows.row.name"/>
                </template>
            </el-table-column>
            <el-table-column label="编码" prop="code">
                <template slot-scope="rows">
                    <el-input :disabled="rows.row.execState == 2" type="text" @change="handleChangeEvent(rows.row)" v-model="rows.row.code"/>
                </template>
            </el-table-column>
            <el-table-column label="校验结果" align="center">
                <template slot-scope="rows">
                    <span class="stateinfo">
                        <i v-if="rows.row.checkState == 1" class="icon iconfont icon-success small font-green"></i>
                        <i v-if="rows.row.checkState == -1" class="icon iconfont icon-error small font-red"></i>
                    </span>
                    <el-tooltip v-if="rows.row.checkState <0" class="item" effect="dark" placement="top">
                        <span slot="content" style="white-space: pre-wrap" v-html="rows.row.checkMsg"></span>
                        <span class="col-title-tooltip-wrapper"><i class="el-icon-question col-title-tooltip"></i></span>
                    </el-tooltip>
                </template>
            </el-table-column>
            <el-table-column label="执行结果" align="center">
                <template slot-scope="rows">
                    <span class="stateinfo">
                        <img v-show="rows.row.execState == 1" class="icon-loading" v-resc-url="'/image/loading.gif'"/>
                        <i v-show="rows.row.execState == 2" class="icon iconfont icon-success small font-green"></i>
                        <i v-show="rows.row.execState == -1" class="icon iconfont icon-error small font-red"></i>
                    </span>
                    <el-tooltip v-if="rows.row.execState <0" class="item" effect="dark" placement="top">
                        <span slot="content" style="white-space: pre-wrap" v-html="rows.row.execMsg"></span>
                        <span class="col-title-tooltip-wrapper"><i class="el-icon-question col-title-tooltip"></i></span>
                    </el-tooltip>
                </template>
            </el-table-column>
        </el-table>
        <div class="clearfix">
            <el-pagination background class="fl mt5" v-if="totalCount > 0" :page-size="pageSize" :page-sizes="pageSizes" :current-page="pageNumber" :total="totalCount" @current-change="handlePageChange" @size-change="handleSizeChange" layout="prev, pager, next, jumper, sizes, total"></el-pagination>
            <div class="swb-btn swb-btn-small fr mt10 " @click="execItemImport">执行导入</div>
            <div class="swb-btn swb-btn-small fr mt10 mr10" @click="checkItemRows">校验检查</div>
            <!--<div class="swb-btn swb-btn-small fr mt10 mr10" @click="downloadDevcBrandImpModel">导出全部品牌</div>-->
        </div>

    </div>
</template>

<script>
    import { Utils } from '../../app.base'
    import { Vue, MsgBox, Routes, VRowId } from '../../app.vues'

    import { getDefaultPageSizes } from '../../../src/app.conf'
    import shopDevcApi from '../../api/shopDevc'

    export default {
        name: 'swb-devc-brand-imp-check',
        desc: '',
        props: ['fileObj'],
        data: function () {
            return {
                pageNumber: 1,
                totalCount: 1,
                pageSize: 10,
                pageSizes: getDefaultPageSizes(),
                pagedevcBrandImpInfoList: [],
                devcBrandImpDto: {
                    originalFileName: null,
                    devcBrandImpInfoList: []
                },
                checkPassed: false,
                assetDeprMethod: [],
                //
                rowItemKey: 'vRowId',
            }
        },
        created: function () {
            this.theVRowId = VRowId.newOne().name(this.rowItemKey);
            //
            this.pageSize = this.pageSizes.first();
            //
            let self = this;
            this.devcBrandImpDto.originalFileName = this.fileObj.extra.originalFileName;
            let devcBrandImpInfoList = this.fileObj.extra.devcBrandImpInfoList;
            //设置初始检查+执行状态
            devcBrandImpInfoList.forEach(function (item) {
                item.checkState = 0;
                item.execState = 0;
            });
            //
            this.theVRowId.setIds(devcBrandImpInfoList);
            this.devcBrandImpDto.devcBrandImpInfoList = devcBrandImpInfoList;

            self.setPageDevcBrandImpInfoList();

        },
        destroyed() {
            this.fileObj = null;
            //
            this.theVRowId = null;
        },
        methods: {
            getRowNo(rowIndex) {
                let baseCount = (this.pageNumber - 1) * this.pageSize;
                return baseCount + rowIndex + 1;
            },
            getDlgResult: function () {
                return this.devcBrandImpDto;
            },
            handleSizeChange: function (val) {
                let curStartIndex = (this.pageNumber - 1) * this.pageSize;
                this.pageSize = val;
                let newPageNumber = Math.max(1, Math.ceil(curStartIndex / this.pageSize));
                this.handlePageChange(newPageNumber);
            },
            handlePageChange: function (val) {
                this.pageNumber = val;
                this.setPageDevcBrandImpInfoList();
            },
            setPageDevcBrandImpInfoList: function () {
                let totalRows = this.devcBrandImpDto.devcBrandImpInfoList;
                let start = (this.pageNumber - 1) * this.pageSize;
                let end = this.pageNumber * this.pageSize;
                let rows = totalRows.slice(start, end);
                this.pagedevcBrandImpInfoList = rows;
                this.totalCount = totalRows.length;
            },
            handleChangeEvent: function (row) {
                this.checkItemRows();
            },
            checkItemRows: function (rowIndex) {
                let devcBrandImpInfoList = this.devcBrandImpDto.devcBrandImpInfoList;
                //
                let codeSeqNoMap = {};
                let nameSeqNoMap = {};
                //
                for(let i = 0, count = devcBrandImpInfoList.length; i < count; i++) {
                    let devcBrandImpInfo = devcBrandImpInfoList[i];
                    let execState = devcBrandImpInfo.execState;
                    if(execState <= 0) {
                        devcBrandImpInfo.checkState = 0;
                        //
                        devcBrandImpInfo.checkMsg = null;
                        devcBrandImpInfo.execMsg = null;
                        //
                        let errMsgs = [];
                        let name = devcBrandImpInfo.name;
                        if(Utils.isNoB(name)) {
                            errMsgs.push("请填写对应的名称");
                        } else {
                            let prevSeqNo = nameSeqNoMap[name];
                            if(prevSeqNo != null) {
                                errMsgs.push('名称与 ' + (prevSeqNo) + '行的名称重复');
                            } else {
                                nameSeqNoMap[name] = i + 1;
                            }
                        }
                        let code = devcBrandImpInfo.code;
                        if(Utils.isNoB(code)) {
                            errMsgs.push('编码不可为空');
                        } else {
                            let prevSeqNo = codeSeqNoMap[code];
                            if(prevSeqNo != null) {
                                errMsgs.push('编码与 ' + (prevSeqNo) + '行的编码重复');
                            } else {
                                codeSeqNoMap[code] = i + 1;
                            }
                        }
                        if(errMsgs.length > 0) {
                            devcBrandImpInfo.checkMsg = errMsgs.join("<br/>");
                            devcBrandImpInfo.checkState = -1;
                        }
                        else {
                            devcBrandImpInfo.checkState = 1;
                        }
                        //
                        devcBrandImpInfo.execState = 0;
                    }
                }
                this.devcBrandImpDto.devcBrandImpInfoList = Utils.merge([], devcBrandImpInfoList);
                this.setPageDevcBrandImpInfoList();
            },
            execItemImport: function () {
                //
                this.doItemImport(null);
            },
            downloadDevcBrandImpModel: function () {
                let devcBrandImpDto = this.devcBrandImpDto;
                let postData = {
                    originalFileName:devcBrandImpDto.originalFileName,
                    impInfoList:devcBrandImpDto.devcBrandImpInfoList
                }
                shopDevcApi.devcBrandImpModelForExport(postData, function (result) {
                    if(result.type == 'info') {
                        Utils.downloadFile(getAppUrl(result.data));
                    } else {
                        MsgBox.warning(result.message);
                    }
                });
            },
            doItemImport: function (prevRowId) {
                let self = this;
                //
                let devcBrandImpInfoList = this.devcBrandImpDto.devcBrandImpInfoList;
                let prevIndex = -1;
                if(prevRowId != null) {//首次執行
                    prevIndex = devcBrandImpInfoList.indexOf(null, function (item) {
                        return item[self.rowItemKey] == prevRowId;
                    });
                }
                //找到下一個
                let nextIndex = devcBrandImpInfoList.indexOf(null, prevIndex + 1, function (item) {
                    return item.execState <= 0 && item.checkState == 1;
                });

                if(nextIndex < 0) {
                    //
                    let allDone = devcBrandImpInfoList.every(function (item) {
                        return item.execState == 2;
                    });
                    if(allDone) {
                        self.$emit('other-close');
                    }
                    //
                    return;
                }
                //
                let devcBrandImpInfo = devcBrandImpInfoList[nextIndex];
                let vRowId = devcBrandImpInfo[self.rowItemKey];
                //
                let theLoading = MsgBox.loading("总第 " + (nextIndex + 1) + " 行数据...");
                devcBrandImpInfo.execState = 1;//
                this.$set(devcBrandImpInfoList, nextIndex, devcBrandImpInfo);
                let postData = {
                    impInfoList: devcBrandImpInfoList,
                    impInfo: devcBrandImpInfo
                }
                shopDevcApi.doImportDevcBrand(postData, function (result) {
                    theLoading.close();
                    if(result.type == 'info') {
                        let execMsg = result.data;
                        if(Utils.isNoB(execMsg)) {
                            devcBrandImpInfo.execState = 2;
                            devcBrandImpInfo.execMsg = null;
                        }
                        else {
                            devcBrandImpInfo.execState = -1;
                            devcBrandImpInfo.execMsg = execMsg;
                        }
                    }
                    else {
                        devcBrandImpInfo.execState = -1;
                        devcBrandImpInfo.execMsg = result.message;
                        //
                        MsgBox.warning(result.message);
                    }
                    //
                    self.$set(devcBrandImpInfoList, nextIndex, devcBrandImpInfo);
                    //
                    self.doItemImport(vRowId);
                });

            }
        }
    }
</script>



// WEBPACK FOOTER //
// src/compo/categ/DevcBrandImpCheck.vue